import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { ScreenClassRender } from 'react-grid-system';

import YellowButton from '../YellowButton';

import styles from './CallToActionBanner.less';

export default class CallToActionBanner extends Component {
  static propTypes = {
    buttonText: PropTypes.string.isRequired,
    heading: PropTypes.string.isRequired,
    href: PropTypes.string,
    onClick: PropTypes.func.isRequired,
  };

  render() {
    return (
      <ScreenClassRender render={this.renderBanner}>
        <span />
      </ScreenClassRender>
    );
  }

  renderBanner = (sc: any) => {
    const titleClassName = classNames({
      [styles.title]: true,
      [styles.smallScreenTitle]: sc === 'xs' || sc === 'sm',
    });

    const buttonClassName = classNames({
      [styles.button]: true,
      [styles.smallScreenButton]: sc === 'xs' || sc === 'sm',
    });

    return (
      <div className={styles.callToActionBanner}>
        {/* @ts-expect-error [MC-2850] - TS2532 - Object is possibly 'undefined'. */}
        <h4 className={titleClassName}>{this.props.heading}</h4>
        <YellowButton
          className={buttonClassName}
          // @ts-expect-error [MC-2850] - TS2532 - Object is possibly 'undefined'.
          href={this.props.href}
          // @ts-expect-error [MC-2850] - TS2532 - Object is possibly 'undefined'.
          onClick={this.props.onClick}
          spacing="compact"
          // @ts-expect-error [MC-2850] - TS2532 - Object is possibly 'undefined'.
          text={this.props.buttonText}
        />
      </div>
    );
  };
}
